module.exports = __webpack_public_path__ + "img/13.29be5121.jpg";